<template>
  <component v-bind="renderer" :is="renderer.is" v-if="renderer.inFocus"/>
</template>

<script>
  import labPlayerRenderer from './lab-player-renderer'
  import imageRenderer from './image-renderer'
  import wbpRenderer from './wbp-renderer'
  import { LAB_TYPE, IMAGE_TYPE, WBP_TYPE } from '../../../enums/render-type'

  export default {
    name: 'lesson-renderer',
    props: ['inFocus', 'activityInfo', 'EUResource'],
    computed: {
      serverRegion() {
        return this.EUResource ? 'eu1' : 'default'
      },
      renderer() {
        switch (this.activityInfo.renderType) {
          case LAB_TYPE:
            return {
              is: labPlayerRenderer,
              activity: this.activityInfo.activity,
              region: this.serverRegion,
              inFocus: this.inFocus
            }
          case IMAGE_TYPE:
            return {
              is: imageRenderer,
              preview: this.activityInfo.preview,
              inFocus: this.inFocus
            }
          case WBP_TYPE: {
            return {
              is: wbpRenderer,
              inFocus: this.inFocus,
              region: this.serverRegion,
              pageLpp: this.activityInfo.activity.lesson.wholeclass || this.activityInfo.activity.lesson.workspace || this.activityInfo.activity.lesson.handout
            }
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
